// extracted by mini-css-extract-plugin
export default {"header":"styles_header__p0gnh","titleWrapper":"styles_titleWrapper__nigK5"};